<div class="container-fluid">
    <div class="row mb-3">
        <div class="col">
            <div>
                <ngb-datepicker #dp [displayMonths]="1" [dayTemplate]="t" [firstDayOfWeek]="7" (navigate)="onMonthChange($event)"> </ngb-datepicker>

                <ng-template #t let-date let-focused="focused">
                    <span class="custom-day" [class.selected]="isSelected(date)" [class.range-start]="isRangeStart(date)" [class.range-end]="isRangeEnd(date)" [class.in-range]="isInRange(date)" (mouseenter)="onDateHover(date)" (click)="onDateSelect(date)">
                        {{ date.day }}
                    </span>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="row mb-2">
        <div class="col d-flex justify-content-evenly">
            <button class="btn btn-outline-primary btn-sm" appLoadingButton (click)="onDateRangeSelected()" [disabled]="!!!startDate && !!!endDate"><i class="fas fa-search me-2"></i>Ver eventos</button>
            <button class="btn btn-outline-primary btn-sm" appLoadingButton (click)="clear()" [disabled]="!!!startDate && !!!endDate"><i class="fas fa-window-close me-2"></i>Limpiar</button>
        </div>
    </div>
    <div class="row">
        <div class="col text-center">
            <small class="text-muted"> En el calendario podrás revisar y recordar todos los eventos programados de tu interés. Selecciona la(s) fecha(s) para buscar tus eventos. </small>
        </div>
    </div>
</div>
